import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import {
  VentaRapidaAssignRequest,
  VentaRapidaAssignResponse,
} from 'src/app/models/venta-rapida/venta-rapida-assign.model';

@Injectable({ providedIn: 'root' })
export class VentaRapidaAssignService {
  private readonly endpoint = `${environment.api_server}/api/v2/assign-products/assign`;

  constructor(
    private readonly http: HttpClient,
    private readonly _api: ApiService,
  ) {}

  assign(request: VentaRapidaAssignRequest): Observable<VentaRapidaAssignResponse> {
    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this.http.post<VentaRapidaAssignResponse>(this.endpoint, request, { headers })
      )
    );
  }
}
